<template lang="pug">
  v-dialog(v-model='dialog2' scrollable persistent max-width='80%')
    v-card(color='grey_1')
      v-app-bar(dark color='primary')
        span.headline Detalles
      v-card-text
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-text
                v-col(cols='12' sm='12' md='12')
                  v-data-table.elevation-1(:headers='headers' item-key='FormPadre' :items='FormPadre' :search='search' sort-by='codigo' :loading='loading' loading-text='Cargando, por favor espere...')
                    template(v-slot:top)
                      v-toolbar(flat color='primary' dark)
                        v-toolbar-title Cobros
                        v-divider.mx-4(inset vertical)
                        v-spacer
                        v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
                        v-spacer
                    template(v-slot:no-data='')
                      h1 No hay Pagos asociados
      v-card-actions
        v-spacer
        v-btn(color='error' small dark @click='close')
          v-icon mdi-close
          | Cancelar
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Api from '@/services/methods'
export default {
  props: ['dialog2', 'FormPadre', 'read'],
  data: () => ({
    loading: true,
    headers: [
      { text: 'Factura', align: 'left', sortable: false, value: 'idVenta.numFactura' },
      { text: 'Cliente', align: 'center', sortable: false, value: 'idVenta.idPedido.idCliente.nombre' },
      { text: 'Monto', align: 'center', sortable: false, value: 'monto' },
      { text: 'Forma de pago', align: 'center', sortable: false, value: 'idTipoPago.descripcion' },
      { text: 'Concepto', align: 'center', sortable: false, value: 'idConcepto.nombre' },
      { text: 'Descripcion', align: 'center', sortable: false, value: 'descripcion' },
      { text: 'Confirmación', value: 'confirmado', align: 'right', sortable: false }
    ],
    dialog3: false,
    search: '',
    pago: [],
    permisosRuta: {},
    editedIndex: -1,
    editedItem: {
      codigo: '',
      descripcion: ''
    },
    defaultItem: {
      codigo: '',
      descripcion: ''
    }
  }),
  components: {

  },
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    FormPadre (val) {
      // formulario que llega del padre, para editar y ver
      if (Object.keys(val).length !== 0) {
        this.form = val
      }
    }
  },
  created () {
    this.initialize()
    // this.permisosRuta = this.$store.state.empresa[0].permisos.find(permiso => permiso.ruta == "Almacen")
  },

  methods: {
    initialize () {
    },
    // validarCrear(){
    //   return this.permisosRuta.accion.includes('Crear')
    // },
    // validarModificar(){
    //   return this.permisosRuta.accion.includes('Modificar')
    // },
    // validarEliminar(){
    //   return this.permisosRuta.accion.includes('Eliminar')
    // },
    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },

    editItem (item) {
      this.editedIndex = this.pago.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog3 = true
    },

    // deleteItem(item) {
    //   console.log(item);
    //   const index = this.pago.indexOf(item);
    //   this.$swal({
    //     icon: "warning",
    //     title: "¿Seguro que quiere borrar?",
    //     text: "No podrá revertir",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "Si, borrar",
    //     cancelButtonText: "cancelar"
    //   }).then(result => {
    //     if (result.value) {
    //       this.$swal("Borrado!", "Su registro fue borrado.", "success");
    //       this.almacen.splice(index, 1);
    //       Api.put("/almacen/deletelog/" + item._id).then(response => {
    //         console.log(response);
    //       });
    //     }
    //   });
    // },

    close () {
      setTimeout(() => {
        // this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
      this.$emit('close')
    },

    permissDenied (status) {
      if (status === '403') {
        this.$swal({
          icon: 'error',
          title: 'Permiso denegado',
          text: 'No tiene pemisos suficientes para ver esta página',
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'ok',
          onAfterClose: () => {
            window.location.href = '/home'
          }
        })
      }
    }

  }
}
</script>
